module.exports = __webpack_public_path__ + "img/LogoBlack.174be503.png";